import { render, staticRenderFns } from "./tabMenu.vue?vue&type=template&id=543e95d0&"
import script from "./tabMenu.vue?vue&type=script&lang=js&"
export * from "./tabMenu.vue?vue&type=script&lang=js&"
import style0 from "./tabMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports